/**
 * 导出邀请码
 * Create by liaokai on 2020-06-11 18:38:31
 */
import {toPost} from "../../http-utils";

export const exportMessageExportIndexUrl = toPost<
    {
        live_id : any
        start_time ?: string
        end_time ?: string
        content ?: string
    },
    {
        url : string
    }
>("/merchant/live/exportMessageExportIndexUrl");
